module.exports = __webpack_public_path__ + "media/audio2.e9ed24d5.mp3";